import React, { useEffect, useState, useMemo } from 'react';
import { fetchRows, getDeltaDayFormattedDate } from '../helpers';

import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col } from "reactstrap";
import { Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const HistoryViewer = ({ url }) => {
    const [historyRows, setHistoryRows] = useState([]);
    const [modal, setModal] = useState(false);
    const briefing = useSelector((state) => state.briefing.line);
    
    const [startDate, setStartDate] = useState(getDeltaDayFormattedDate(1)); // Set default state to today's date - 1 month
    const [endDate, setEndDate] = useState(getDeltaDayFormattedDate(-1)); // Set default state to today's date

    const toggle = () => setModal(!modal);
    
    useEffect(() => {
        const fetchHistory = async () => {
            try {
                const data = await fetchRows(
                    url,
                    briefing,
                    { "startDate": startDate, "endDate": endDate },
                    "history",
                );
                setHistoryRows(data);
            } catch (error) {
                console.error('Error fetching history:', error);
            }
        };

        if (modal) {
            fetchHistory();
        }
    }, [modal, url, startDate, endDate]);

    const buttonGroupComponent = useMemo(() => (
        <div className="row d-flex">
            <div className='col' style={{ width: 'auto' }}>
                <strong>Change History</strong>
            </div>
            <div className='col d-flex justify-content-end align-items-center'>
                <div className="form-group">
                    <label className="label-text">Filter Start:</label>
                    <Form.Control
                        defaultValue={startDate}
                        className='btn btn-sm tab-btn'
                        type='date'
                        onChange={(e) => setStartDate(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label className="label-text">Filter End:</label>
                    <Form.Control
                        value={endDate}
                        className='btn btn-sm tab-btn'
                        type='date'
                        onChange={(e) => setEndDate(e.target.value)}
                    />
                </div>
            </div>
        </div>
    ), [startDate, endDate]);

    const HistoryTable = () => (
        <table className='change-history-table'>
            <thead>
                <tr>
                    <th>Row ID</th>
                    <th>User</th>
                    <th>Effect</th>
                    <th>Change Date</th>
                </tr>
            </thead>
            <tbody>
                {historyRows && historyRows.map((change, index) => (
                    <tr key={index}>
                        <td className="history-row-id-cell">
                            <div className="row-id-div">
                                {change.row_id}
                            </div>
                        </td>
                        <td style={{ width: "12%" }}>
                            {change.user_username.replace("@shipces.com", '')}
                        </td>
                        <td>{change.effect}</td>
                        <td style={{ width: "15%" }}>
                            {change.change_datetime}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );

    return (
        <>
            <button
                className='btn-history'
                onClick={toggle}
                title="History"
            >
                <i className='fa fa-history'></i>
            </button>

            <Modal
                isOpen={modal}
                toggle={toggle}
            >
                <ModalHeader className='bg-dark text-white text-center p-3' toggle={toggle}>
                    {buttonGroupComponent}
                </ModalHeader>
                <ModalBody className="m-0 mt-1 text-center p-1">
                    <Row>
                        <Col>
                            <div>
                                <HistoryTable />
                            </div>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button className='btn bg-danger text-white border-0' onClick={toggle}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default HistoryViewer;
